import { globalRemoveMaskReal2 } from "../../../../shared/utils";

export interface RawCoverage {
	id: string;
	name: string;
	coverageId?: string;
	factor?: number;
	limite_min?: string | number;
	limite_max?: string | number;
	rate_increase?: string;
	status?: string;
	value?: string;
	enabled?: boolean;
	coverage_value?: number;
	is_changed_by_user?: boolean;
}

interface CalculateCoveragesParams {
	coverages: RawCoverage[];
	rentValue?: string;
	quotationId?: string;
}

export const calculateCoveragesValues = ({ coverages, rentValue, quotationId }: CalculateCoveragesParams): RawCoverage[] => {
	if (!coverages || !coverages.length) return [];

	const rent = Number(globalRemoveMaskReal2(rentValue ?? "0"));
	const isNewQuotation = quotationId === "novo" || !quotationId; // Treat undefined as new/create mode context if needed, or rely on caller

	return coverages.map((c, idx) => {
		// Se foi alterado manualmente, preserva o valor (se a flag estiver presente)
		if (c.is_changed_by_user) {
			return c;
		}

		const factor = Number(c.factor ?? 1);
		const limiteMin = Number(c.limite_min ?? 0);
		const limiteMax = Number(c.limite_max ?? 0);

		let calculatedValue = Number(c.coverage_value ?? c.limite_min ?? 0);

		// 🔹 Nova cotação (ou recálculo explícito) → calcula com base no aluguel e fator
		// Se rent > 0, assumimos que devemos recalcular se não foi alterado manualmente
		if (rent > 0 && factor > 0) {
			calculatedValue = rent * factor;

			// 🔒 Garante que o valor fique dentro dos limites permitidos
			if (limiteMin && calculatedValue < limiteMin) calculatedValue = limiteMin;
			if (limiteMax && calculatedValue > limiteMax) calculatedValue = limiteMax;
		}

		// 💰 Formata o valor final igual ao card
		const formattedValue = calculatedValue.toLocaleString("pt-BR", {
			style: "currency",
			currency: "BRL",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});

		return {
			...c,
			id: c.id ?? String(idx),
			coverage_value: calculatedValue, // ✅ Retorna valor numérico
			value: formattedValue, // ✅ valor formatado
			enabled: c.enabled ?? true,
		};
	});
};
